import { Heading, OrgAvatar, Text } from "@athena/ui";
import { Users } from "lucide-react";

interface StepReviewProps {
    courseTitle: string;
    courseId: string;
    selectedOrgs: Set<string>;
    selectedPeople: Set<string>;
    fixedDate: string;
    // sendNudges: boolean;
}

export const StepReview = ({
    courseTitle,
    courseId,
    selectedOrgs,
    selectedPeople,
    fixedDate,
    // sendNudges,
}: StepReviewProps) => {
    const totalPeople = selectedPeople.size;
    const initials = courseTitle
        .split(" ")
        .slice(0, 2)
        .map((w) => w[0])
        .join("")
        .toUpperCase();

    const audienceSummary = (() => {
        if (totalPeople > 0 && selectedOrgs.size > 0)
            return `${selectedOrgs.size} org${selectedOrgs.size !== 1 ? "s" : ""} + ${totalPeople} ${totalPeople === 1 ? "user" : "users"}`;
        if (selectedOrgs.size > 0) return `${selectedOrgs.size} organization${selectedOrgs.size !== 1 ? "s" : ""}`;
        if (totalPeople > 0) return `${totalPeople} ${totalPeople === 1 ? "user" : "users"}`;
        return "No audience selected";
    })();

    const dueSummary = (() => {
        // const nudge = sendNudges ? " · reminders on" : "";
        if (fixedDate)
            return `${new Date(fixedDate + "T00:00:00").toLocaleDateString(undefined, { month: "long", day: "numeric", year: "numeric" })}`;
        // Said out loud rather than left blank: an empty value next to "Due" reads as something
        // the wizard failed to fill in, when it is a deliberate choice the operator just made.
        return "No due date";
    })();

    return (
        <div className="flex flex-col gap-5">
            <div>
                <Heading level={3}>Review &amp; confirm</Heading>
                <Text muted className="text-sm">
                    Here's what you're about to set up.
                </Text>
            </div>

            <div className="border-border divide-border divide-y overflow-hidden rounded-xl border">
                <div className="flex items-center gap-4 px-5 py-4">
                    <Text muted className="w-24 shrink-0 text-xs font-semibold tracking-wide uppercase">
                        Course
                    </Text>
                    <div className="flex items-center gap-3">
                        <OrgAvatar id={courseId} fallback={initials} size="sm" />
                        <Text weight="semibold" className="text-sm">
                            {courseTitle}
                        </Text>
                    </div>
                </div>
                <div className="flex items-center gap-4 px-5 py-4">
                    <Text muted className="w-24 shrink-0 text-xs font-semibold tracking-wide uppercase">
                        Audience
                    </Text>
                    <div className="flex items-center gap-2 rounded-full bg-gray-100 px-3 py-1">
                        <Users className="text-muted-foreground h-3.5 w-3.5" />
                        <Text className="text-sm">{audienceSummary}</Text>
                    </div>
                </div>
                <div className="flex items-center gap-4 px-5 py-4">
                    <Text muted className="w-24 shrink-0 text-xs font-semibold tracking-wide uppercase">
                        Due
                    </Text>
                    <Text className="text-sm">{dueSummary}</Text>
                </div>
            </div>

            {/* <div className="grid grid-cols-2 gap-3">
                <div className="bg-foreground rounded-xl px-6 py-5">
                    <Text className="text-background/60 mb-2 text-xs font-semibold tracking-wide uppercase">
                        Will assign to
                    </Text>
                    <div className="flex items-baseline gap-2">
                        <span className="text-background text-5xl font-bold">{willAssign}</span>
                        <Text className="text-background/80 text-lg">people</Text>
                    </div>
                </div>
                <div className="bg-muted/50 border-border rounded-xl border px-6 py-5">
                    <Text muted className="mb-2 text-xs font-semibold tracking-wide uppercase">
                        Skipped
                    </Text>
                    <div className="flex items-baseline gap-2">
                        <span className="text-muted-foreground text-5xl font-bold">0</span>
                        <Text muted className="text-lg">
                            already done
                        </Text>
                    </div>
                </div>
            </div> */}
        </div>
    );
};
